<template>
    <v-container fluid class="max-width">
      <v-card>
        <v-toolbar color="secondary" flat dense>
          <v-toolbar-title>Product Barcode</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn small text to="/products">
            <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
          </v-btn>
        </v-toolbar>
  
        <v-card-text>
          <!-- editor -->
          <editor :docCreate="docCreate" :initial="dataItem" @data="save"></editor>
          <!-- end -->
        </v-card-text>
      </v-card>
  
      <!-- snackbar -->
      <snackbar ref="snackbar"></snackbar>
    </v-container>
  </template>
  
  <script>
  import Editor from "../_components/barcode-editor.vue";
  export default {
    components: {
      Editor
    },
    data: () => ({
      dataItem: {},
      docCreate: false
    }),
    watch: {
      "$route.params.id": {
        handler: "getById",
        immediate: true
      }
    },
    methods: {
      getById(val) {
        const self = this;
        this.$store
          .dispatch("get", `/products-barcode/${val}`)
          .then(res => {
            if (res.ResultCode == 1200) {
              self.dataItem = res.ResponseData;
  
              var barCode = res.ResponseData['BarCode'];
              console.log(barCode, " barcode ");
            } else {
              this.$refs.snackbar.show(res.msg, "red");
            }
          })
          .catch(err => {
            this.$refs.snackbar.show(err, "red");
          });
      },
      save(data) {
        const url = `/products/${data.id}`;
        const self = this;
        this.$store
          .dispatch("put", { url, data })
          .then(res => {
            if (res.ResultCode == 1200) {
              self.$store.commit("btnLoader", false);
              location.reload();
            } else {
              self.$store.commit("btnLoader", false);
              this.$refs.snackbar.show(res.msg, "red");
            }
          })
          .catch(err => {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(err, "red");
          });
      }
    }
  };
  </script>